import { type CustomerLifecycleStage } from '@libraries/typescript/api_client';

// Allowlist mirrors the backend `ENABLED_LIFECYCLE_STAGES`: the general agent
// is available only to actively-working orgs (and Phoebe's own internal orgs).
// Every other stage — including an unset/loading stage — is ineligible, so the
// entry point stays hidden until the org record confirms an enabled stage.
const AGENT_ENABLED_LIFECYCLE_STAGES: ReadonlySet<CustomerLifecycleStage> =
    new Set(['implementing', 'live', 'internal']);

export function isGeneralAgentLifecycleEligible(
    customerLifecycleStage: CustomerLifecycleStage | null | undefined,
): boolean {
    if (!customerLifecycleStage) {
        return false;
    }
    return AGENT_ENABLED_LIFECYCLE_STAGES.has(customerLifecycleStage);
}

// The callout detail route docks an outreach-scoped chat rather than the
// general agent, so callers that need the general composer (for example
// seeding a Learn Phoebe prompt) must leave this route first.
export function getCalloutDetailOutreachId(pathname: string): string | null {
    return /^\/outreaches\/([^/]+)$/.exec(pathname)?.[1] ?? null;
}

type ChatAccessOptions = {
    readonly customerLifecycleStage?: CustomerLifecycleStage | null;
};

export function canAccessPhoebeChat({
    customerLifecycleStage,
}: ChatAccessOptions): boolean {
    if (!isGeneralAgentLifecycleEligible(customerLifecycleStage)) {
        return false;
    }

    return true;
}
